import React, { Component } from 'react';

class DynamicMessage extends Component {
	constructor(props) {
		super(props);

		this.state = {
			containerWidth:  '',
			css:             props.CSSModules[props.condor_render_name],
			currentItem:     0,
			previousItem:    0,
			nextItem:        0,
			numMessages:     0,
			wipe:            false,
			runningInterval: 0
		};

		this.divRef = React.createRef();
		this.initialize = this.initialize.bind(this);
		this.startMessageTimer = this.startMessageTimer.bind(this);
		this.stopMessageTimer = this.stopMessageTimer.bind(this);
		this.cycleMessages = this.cycleMessages.bind(this);
	}

	componentDidMount() {
		this.stopMessageTimer();

		// React 19 fix: Wait for fonts and CSS to load before initializing
		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(() => {
				setTimeout(() => {
					this.initialize();
				}, 100); // Reduced from 1500ms since fonts are ready
			});
		} else {
			// Fallback for browsers without font loading API
			setTimeout(() => {
				this.initialize();
			}, 1500);
		}
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.message_list !== this.props.message_list ||
			prevProps.transition_time !== this.props.transition_time
		) {
			this.stopMessageTimer();
			this.initialize();
		}
	}

	componentWillUnmount() {
		// Clean up when unmounting
		this.stopMessageTimer();
	}

	initialize() {
		this.stopMessageTimer();

		let numMessages = 0;
		if (Array.isArray(this.props.message_list)) {
			numMessages = this.props.message_list.length;
		}

		// React 19 fix: Triple RAF for more reliable layout flush in concurrent rendering
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					let containerWidth = 0;
					if (this.divRef.current) {
						containerWidth = this.divRef.current.offsetWidth;

						// Safety check: if width is 0, retry initialization
						if (containerWidth === 0) {
							setTimeout(() => this.initialize(), 100);
							return;
						}
					}

					this.setState({
						containerWidth,
						numMessages,
						currentItem: 0,
						nextItem:    1,
						previousItem: 2
					}, () => {
						if (numMessages > 1) {
							const durationMs = (this.props.transition_time || 5) * 1000;
							setTimeout(() => {
								this.startMessageTimer(durationMs);
							}, 500);
						}
					});
				});
			});
		});
	}

	startMessageTimer(duration) {
		clearInterval(this.state.runningInterval);
		const localTimer = setInterval(() => {
			this.cycleMessages();
		}, duration);
		this.setState({ runningInterval: localTimer });
	}

	stopMessageTimer() {
		clearInterval(this.state.runningInterval);
	}

	cycleMessages() {
		const { currentItem, nextItem, previousItem, numMessages } = this.state;
		let newCurrent = currentItem + 1;
		let newNext    = nextItem + 1;
		let newPrev    = previousItem + 1;

		if (newCurrent > numMessages - 1) { newCurrent = 0; }
		if (newNext > numMessages - 1)    { newNext = 0; }
		if (newPrev > numMessages - 1)    { newPrev = 0; }

		this.setState({
			currentItem:  newCurrent,
			nextItem:     newNext,
			previousItem: newPrev,
			wipe:         true
		});

		setTimeout(() => {
			this.setState({ wipe: false });
		}, 1000);
	}

	render() {
		const {
			containerWidth,
			currentItem,
			nextItem,
			previousItem,
			wipe
		} = this.state;

        // Custom classes
		let customClasses = '';
		if (Array.isArray(this.props.custom_classes)) {
			this.props.custom_classes.forEach((className) => {
				if ((/^([a-z_]|-[a-z_-])[a-z\d_-]*$/i).test(className)) {
					customClasses += ` ${className}`;
				}
			});
		}

		let modifierClasses = '';
		if (Array.isArray(this.props.modifier_classes)) {
			this.props.modifier_classes.forEach((className) => {
				if ((/^([a-z_]|-[a-z_-])[a-z\d_-]*$/i).test(className)) {
					modifierClasses += ` ${className}`;
				}
			});
		}

		const css = this.state.css;
		let animationType = 'Fade'; // default
		switch (this.props.animation_type) {
			case 0: 
                animationType = 'Pop';  
                break;
			case 1: 
                animationType = 'Fade'; 
                break;
			case 2: 
                animationType = 'Roll'; 
                break;
			case 3:
                animationType = 'Slide'; 
                break;
			case 4:
                animationType = 'Wipe';  
                break;
			default:
                animationType = 'Fade';
		}

		// Build the messages array with correct classes
		let messages = [];
		if (Array.isArray(this.props.message_list)) {
			const message_list = [...this.props.message_list];
			if (message_list.length === 2) {
				message_list.push(...this.props.message_list);
			}

			messages = message_list.map((msg, i) => {
				let animationClass = 'has'; // fallback
				if (i === currentItem) {
					animationClass = 'is';
				} else if (i === nextItem) {
					animationClass = 'will';
				}

				const transitionClass = css[`${animationClass}${animationType}`] || '';
				const msgClass = (this.props.animation_type === 4) ? css.wipeMsg : css.msg;

				return (
					<div
						className={`${transitionClass} ${msgClass}`}
						key={`dynamicMessage_${i}_${this.props.component_name}`}
					>
						{msg}
					</div>
				);
			});
		}

		if (this.props.animation_type === 4) {
			const containerWidthStyle = { width: `${containerWidth}px` };
			return (
				<div
					ref={this.divRef}
					className={`dynamicMessage_container ${css.cont}${modifierClasses}${customClasses}`}
				>
					<div className={wipe ? css.wipeOff : css.wipeOn}>
						<div className={css.wipe} style={containerWidthStyle}>
							{messages}
						</div>
					</div>
				</div>
			);
		}

		return (
			<div
				ref={this.divRef}
				className={`dynamicMessage_container ${css.cont}${modifierClasses}${customClasses}`}
			>
				{messages}
			</div>
		);
	}
}

export default DynamicMessage;
